import { Injectable } from '@angular/core';

import { CustomRequestService } from '../../../services/custom-request/custom-request.service';
import { LzProductConfig } from '../../../services/product-config/poduct-config';

@Injectable()
export class LzUserServiceV2 {

  private serverTime = {};
  private serverTimeCallbacks = [];

  private userInfo = {};
  private userInfoCallbacks = [];

  private userProductsShort = {};
  private userProductsShortCallbacks = [];

  private userProductsInvoice = {};
  private userProductsInvoiceCallbacks = [];

  private allProducts = {};
  private allProductsCallbacks = [];

  constructor(private config: LzProductConfig, private customRequestService: CustomRequestService) {

  }

  private localCheckServerTime = (callback: any) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/api-utils/common/v1.0/server/time').subscribe((msg) => {
      callback(msg);
    });
  }

  private localCheck = (callback: any) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/lz-platforma/user/v1.0/userInfo').subscribe((msg) => {
      callback(msg);
    });
  }

  private localCheckProductsShort = (callback: any) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/lz-platforma/user/v1.0/userProducts/short').subscribe((msg) => {
      callback(msg);
    });
  }

  private localCheckProductsInvoice = (callback: any) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/lz-platforma/user/v1.0/userProducts/invoice').subscribe((msg) => {
      callback(msg);
    });
  }

  private localCheckAllProducts = (callback: any) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/lz-platforma/product/v1.0/all').subscribe((msg) => {
      callback(msg);
    });
  }

  private deepEquals = (x: any, y: any) => {
    if (x === y) {
      return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
      return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
      // they must have the exact same prototype chain, the closest we can do is
      // test their constructor.
      return false;
    } else {
      for (const p in x) {
        if (!x.hasOwnProperty(p)) {
          continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
          return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
          continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
          return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!this.deepEquals(x[p], y[p])) {
          return false;
        }
      }
      for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    }
  }

  private callUserCallbacks = (callbacks: any, data: any) => {
    let length = callbacks.length;
    if (callbacks.length == 0) return false;
    for (let i = 0; i < length; i++) {
      callbacks[i](data);
    }
  }

  public logout = (callback ? ) => {
    this.customRequestService.getRequest(this.config.getApiLink() + '/lz-platforma/auth/v2.0/authorize/logout').subscribe((msg) => {
      if (callback) {
        callback(msg);
      }
    });
  }


  public getServerTime = (callback) => {
    if (this.deepEquals({}, this.serverTime)) {
      if (this.serverTimeCallbacks.length != 0) {
        this.serverTimeCallbacks.push(callback);
        return;
      }
      this.serverTimeCallbacks.push(callback);
      this.localCheckServerTime((sTime) => {
        this.serverTime = sTime;
        this.callUserCallbacks(this.serverTimeCallbacks, this.serverTime);
      });
    } else {
      callback(this.serverTime);
    }
  }

  public getUserInfo = (callback) => {
    if (this.deepEquals({}, this.userInfo)) {
      if (this.userInfoCallbacks.length != 0) {
        this.userInfoCallbacks.push(callback);
        return;
      }
      this.userInfoCallbacks.push(callback);
      this.localCheck((userInf) => {
        this.userInfo = userInf;
        this.callUserCallbacks(this.userInfoCallbacks, this.userInfo);
      });
    } else {
      callback(this.userInfo);
    }
  }

  public getUserProductsShort = (callback) => {
    if (this.deepEquals({}, this.userProductsShort)) {
      if (this.userProductsShortCallbacks.length != 0) {
        this.userProductsShortCallbacks.push(callback);
        return;
      }
      this.userProductsShortCallbacks.push(callback);
      this.localCheckProductsShort((userProds) => {
        this.userProductsShort = userProds;
        this.callUserCallbacks(this.userProductsShortCallbacks, this.userProductsShort);
      });
    } else {
      callback(this.userProductsShort);
    }
  }

  public getUserProductsInvoice = (callback) => {
    if (this.deepEquals({}, this.userProductsInvoice)) {
      if (this.userProductsInvoiceCallbacks.length != 0) {
        this.userProductsInvoiceCallbacks.push(callback);
        return;
      }
      this.userProductsInvoiceCallbacks.push(callback);
      this.localCheckProductsInvoice((userProds) => {
        this.userProductsInvoice = userProds;
        this.callUserCallbacks(this.userProductsInvoiceCallbacks, this.userProductsInvoice);
      });
    } else {
      callback(this.userProductsInvoice);
    }
  }

  public getAllProducts = (callback) => {
    if (this.deepEquals({}, this.allProducts)) {
      if (this.allProductsCallbacks.length != 0) {
        this.allProductsCallbacks.push(callback);
        return;
      }
      this.allProductsCallbacks.push(callback);
      this.localCheckAllProducts((prods) => {
        this.allProducts = prods;
        this.callUserCallbacks(this.allProductsCallbacks, this.allProducts);
      });
    } else {
      callback(this.allProducts);
    }
  }

  public checkServerTime = this.localCheckServerTime;

  public check = this.localCheck;

  public checkUserProductsShort = this.localCheckProductsShort;

  public checkUserProductsInvoice = this.localCheckProductsInvoice;

  public checkAllProducts = this.localCheckAllProducts;

}
